import React, { InputHTMLAttributes } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  type?: "text" | "password" | "email" | "number" | "date" | "time" | "checkbox";
  value?: string | number;
  classes?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const Input: React.FC<InputProps> = ({ type, value, onChange, classes, ...rest }) => {
  return (
    <input
      className={`w-full px-4 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-red ${classes}`}
      type={type}
      value={value}
      onChange={onChange}
      {...rest}
    />
  );
};

export default Input;
